<script setup>
import { computed } from 'vue';
import Commons from '../../shared/libraries/commons';

const props = defineProps({
  match: {
    required: true,
    type: Object
  }
});

const bestBet = computed(() => {
  const allOdds = props.match?.allOdds;
  if (!allOdds) return null;

  const titles = {
    '1': `Victoire ${props.match?.team1?.name}`,
    '2': `Victoire ${props.match?.team2?.name}`,
    '4': `${props.match?.team1?.name} ou Nul`,
    '5': `${props.match?.team2?.name} ou Nul`,
    '6': 'Double chance 12',
    '7': '+2.5 buts',
    '8': '-2.5 buts',
    '9': 'Les 2 marquent',
    '10': 'Pas les 2'
  };

  const homeWinProb = parseFloat(allOdds['1']?.probability) || 0;
  const awayWinProb = parseFloat(allOdds['2']?.probability) || 0;

  let best = null;
  let bestType = null;

  if (homeWinProb >= 50 || awayWinProb >= 50) {
    if (homeWinProb >= awayWinProb) {
      best = allOdds['1'];
      bestType = '1';
    } else {
      best = allOdds['2'];
      bestType = '2';
    }
  } else {
    const otherTypes = ['4', '5', '6', '7', '8', '9', '10'];
    let highestProb = 0;

    for (const type of otherTypes) {
      const odd = allOdds[type];
      if (odd && odd.probability) {
        const prob = parseFloat(odd.probability);
        if (prob > highestProb) {
          highestProb = prob;
          best = odd;
          bestType = type;
        }
      }
    }
  }

  if (!best) return null;

  return {
    title: titles[bestType] || best.description,
    value: best.value,
    probability: best.probability
  };
});
</script>

<template>
  <div
    class="overflow-hidden bg-white rounded-3xl h-full"
  >
    <!-- date en badge -->
    <div class="px-4 pt-4">
      <div
        class="inline-flex px-3 py-1 text-xs font-semibold text-primary bg-primary/10 rounded-full capitalize"
      >
        {{ Commons.time(match?.date, 'dddd D MMM') }}
      </div>
    </div>

    <!-- teams -->
    <div class="flex items-center justify-between gap-3 px-4 pt-6 pb-1">
      <!-- team 1 -->
      <div class="flex flex-col items-center gap-2 flex-1">
        <div class="w-20 h-20 p-1.5 bg-white rounded-2xl">
          <ImgComponent
            :src="match?.team1?.logo"
            fallback="/images/match/t-shirt.svg"
            class="w-full h-full object-contain"
            alt=""
          />
        </div>
        <div
          class="text-sm font-semibold text-center text-slate-700 line-clamp-2 h-[2lh]"
        >
          {{ match?.team1?.name ?? '' }}
        </div>
      </div>

      <!-- vs -->
      <div class="flex flex-col items-center gap-1 px-2">
        <div class="text-lg font-black text-primary/30">vs</div>
      </div>

      <!-- team 2 -->
      <div class="flex flex-col items-center gap-2 flex-1">
        <div class="w-20 h-20 p-1.5 bg-white rounded-2xl">
          <ImgComponent
            :src="match?.team2?.logo"
            fallback="/images/match/t-shirt.svg"
            class="w-full h-full object-contain"
            alt=""
          />
        </div>
        <div
          class="text-sm font-semibold text-center text-slate-700 line-clamp-2 h-[2lh]"
        >
          {{ match?.team2?.name ?? '' }}
        </div>
      </div>
    </div>
    <!-- {{ match?.allOdds?.['2'] }} -->
    <!-- prediction card -->
    <div
      class="mx-3 mb-3 p-4 bg-secondary-600 rounded-2xl active:scale-[0.98] transition-transform cursor-pointer"
      @click.stop="
        $bus.emit($constants.EVENTS.SERVICES.START, {
          group: 'recharges',
          option: 'fund'
        })
      "
    >
      <div class="flex items-center justify-between gap-3">
        <div class="flex-1">
          <div class="text-sm text-white/80 font-medium mb-1">
            Clique pour déposer
          </div>
          <div class="text-base font-bold text-white leading-tight">
            {{ bestBet?.title }}
          </div>
        </div>
        <div class="flex flex-col items-end">
          <div class="text-2xl font-black text-white">
            {{ bestBet?.probability }}
          </div>
          <div class="text-xs text-white/70">{{ bestBet?.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
